module.exports = __webpack_public_path__ + "static/media/phone-square.79c67236.svg";